module.exports = __webpack_public_path__ + "img/2.93341680.jpg";